// extracted by mini-css-extract-plugin
export default {"container":"TempOrganisationManagementPage_container__TvYwf","title":"TempOrganisationManagementPage_title__K90cS"};